import { useEffect, useState } from "react";

/**
 * Check if the window or tab with the app is active.
 * @returns true if the window is active, false otherwise
 */
export const useTabActive = () => {
  const [isActive, setTabActive] = useState(true);

  useEffect(() => {
    setTabActive(document.visibilityState === "visible");

    const handleVisibilityChange = () => {
      setTabActive(document.visibilityState === "visible");
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isActive;
};
